/**
 * 返回 分钟，时分钟，天小时分钟 例:1天12小时23分
 * @param {date} 时间
 */
function GetDHM (start, end) {
  // direct_time格式为yyyy-mm-dd hh:mm:ss 指定时间
  var now_time = Date.parse(new Date(start));//当前时间的时间戳
  var end_time = Date.parse(new Date(end));//指定时间的时间戳 
  //计算相差天数
  var time_dis = end_time < now_time ? now_time - end_time : end_time - now_time;
  var days = Math.floor(time_dis / (24 * 3600 * 1000));
  //计算出小时数
  var leave1 = time_dis % (24 * 3600 * 1000);//计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000);//计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000);//计算小时数后剩余的毫秒数
  var second = leave3 / 1000;
  return days + "天" + hours + "小时" + minutes + "分" + second + "秒";
}
function GetDiffDate (start, end, type) {
  // direct_time格式为yyyy-mm-dd hh:mm:ss 指定时间
  var now_time = Date.parse(start);//当前时间的时间戳
  var end_time = Date.parse(end);//指定时间的时间戳 
  //计算相差天数
  if (type == 'd')
  {
    var time_dis = end_time < now_time ? now_time - end_time : end_time - now_time;
    return Math.floor(time_dis / (24 * 3600 * 1000));
  }
  else if (type == 'h')
  {
    var leave1 = time_dis % (24 * 3600 * 1000);
    return Math.floor(leave1 / (3600 * 1000));
  }
  else if (type == 'm')
  {
    var leave2 = leave1 % (3600 * 1000);
    return Math.floor(leave2 / (60 * 1000));
  }
  else if (type == 's')
  {
    var leave3 = leave2 % (60 * 1000);//计算小时数后剩余的毫秒数
    return leave3 / 1000;
  }
  return 0;
}
//增加月  
function AddMonths (date, value) {
  date.setMonth(date.getMonth() + value);
  return date;
}
//增加天  
function AddDays (date, value) {
  date.setDate(date.getDate() + value);
  return date;
}
//增加时
function AddHours (date, value) {
  date.setHours(date.getHours() + value);
  return date;
}
//增加分
function AddMinutes (date, value) {
  date.setMinutes(date.getHours() + value);
  return date;
}
function BeforeNow (date) {
  return new Date(date) < new Date();
}
function AfterNow (date) {
  return new Date(date) > new Date();
}
function Between (start, end) {
  return new Date(start) < new Date() && new Date() < new Date(end);
}

export default {
  install (Vue, options) {
    Vue.prototype.$GetDHM = GetDHM;
    Vue.prototype.$AddMonths = GetDHM;
    Vue.prototype.$AddDays = GetDHM;
    Vue.prototype.$AddHours = GetDHM;
    Vue.prototype.$AddMinutes = AddMinutes;
    Vue.prototype.$BeforeNow = BeforeNow;
    Vue.prototype.$AfterNow = AfterNow;
    Vue.prototype.$Between = Between;
  }
}


// WEBPACK FOOTER //
// ./src/utils/date.js